export const HOME = '/';
export const LOGIN = '/login';
export const MESSAGES = '/inspirations';
export const ADD_MESSAGE = '/inspirations/add';
export const EDIT_MESSAGE = '/inspirations/edit';
export const PROGRAMS = '/programs';
export const ADD_PROGRAM = '/programs/add';
export const EDIT_PROGRAM = '/programs/edit';
